/* 
 * EXPANDO
 * ===========================================
 * Expando lets you expand and collapse things, similar to jQuery's show, hide,
 * and toggle functions. Unlike those functions, it can:
 *
 * - Switch between an exerpt and full text
 * - Toggle CSS classes
 * - Use CSS3 animation
 * - Apply minimal inline CSS (set only display: none, not display: block)
 * - Offer a data attribute API and custom events (expando-collapse and expando-expand)
 * - Make coffee! (Ok, not really)
 * 
 * Expando can be combined with togglr to build tabs, accordions, and the like
 * without using a heavy UI library such as jQuery UI.
 *
 * Expando will listen to togglr's activate/deactivate events if togglr is 
 * available. In order to take advantage of this feature, call togglr before
 * calling expando, and make sure require loads both plugins.
 */

; define('core/ef_plugins/expando',["jquery", "libs/jquery.transit"], function (jQuery) {
    (function ($, window, document, undefined) {

        var pluginName = 'expando',
            defaults = {
                activeClass: 'is-active', // Class applied when to $element or the excerpt when it is shown.
                animateClass: 'is-animating', // Class applied to the trigger and the target when togglr is animating.
                animate: true, // Animate transition from excerpt to full text?
                animateTime: 300, // Length of animation (in ms)
                excerpt: ".js-expando-excerpt", // Selector for excerpt to show when expando closed. Must be a sibling of the element on which expando is called.
                trigger: ".js-expando-trigger", // Selector for an element that will toggle the expando when clicked. Must be a sibling or parent of the element on which expando is called. Alternately, you could manually set up click listener and call .toggle() from in there.
                useTogglr: true, // If the trigger uses the togglr plugin, use togglr events instead of the click event.
            };

        // ReSharper disable once InconsistentNaming
        function Expando(element, options) {
            this.element = element;
            this.$element = $(element);
            this.metadata = this.$element.data('expando-options');
            this.options = $.extend({}, defaults, options, this.metadata);
            this._defaults = defaults;
            this._name = pluginName;
            this.init();
        }

        Expando.prototype = {
            init: function () {
                var plugin = this,
                    togglr;
                // Find elements.
                plugin.$excerpt = this.$element.siblings(plugin.options.excerpt);
                plugin.$trigger = this.$element.siblings(plugin.options.trigger);
                if (plugin.$trigger.length === 0) {
                    plugin.$trigger = this.$element.parents(plugin.options.trigger);
                }
                // Set up event listeners.
                togglr = plugin.$trigger.data('plugin_togglr');
                if (togglr && plugin.options.useTogglr) {
                    // Stay in sync with togglr state.
                    plugin.$trigger.on('togglr-activate.expando', function () { plugin.expand(); });
                    plugin.$trigger.on('togglr-deactivate.expando', function () { plugin.collapse(); });
                } else {
                    plugin.$trigger.on('click.expando', function () { plugin.toggle(); });
                }
                // Set collapsed state as the default.
                plugin.expanded = false;
                plugin.$element.css({ 'display': 'none' });
            },

            _animate: function(startHeight, endHeight, callback) {
                var plugin = this;

                if (typeof callback !== 'function') {
                    callback = function() {};
                }
                if (!plugin.options.animate) {
                    callback();
                    return;
                }

                // Set up initial state.
                plugin.$element
                    .addClass(plugin.options.animateClass)
                    .css({
                        'overflow': 'hidden',
                        'height': startHeight
                    });
                // Animate and call the callback.
                plugin.$element.transition({ height: endHeight }, plugin.options.animateTime, function () {
                    plugin.$element.css({
                        'overflow': '',
                        'height': '',
                    });
                    plugin.$element.removeClass(plugin.options.animateClass);
                    callback();
                });
            },

            expand: function () {
                var plugin = this,
                    startHeight,
                    endHeight = plugin.$element.css('height');
                if (plugin.expanded) {
                    return false;
                }

                startHeight = (plugin.$excerpt.length === 0) ? 0 : plugin.$excerpt.css('height');
                plugin.expanded = true;
                plugin.$excerpt
                    .removeClass(plugin.options.activeClass)
                    .css({ 'display': 'none' });
                plugin.$element
                    .addClass(plugin.options.activeClass)
                    .css({ 'display': '' })
                    .trigger('expando-expand');
                    
                plugin._animate(startHeight, endHeight);
                return true;
            },

            collapse: function () {
                var plugin = this,
                    startHeight = plugin.$element.css('height'),
                    endHeight;
                if (!plugin.expanded) {
                    return false;
                }

                endHeight = (plugin.$excerpt.length === 0) ? 0 : plugin.$excerpt.css('height');
                plugin.expanded = false;
                plugin.$excerpt.addClass(plugin.options.activeClass);
                plugin.$element
                    .removeClass(plugin.options.activeClass)
                    .trigger('expando-collapse');
                
                plugin._animate(startHeight, endHeight, function() {
                    plugin.$element.css({ 'display': 'none' });
                    plugin.$excerpt.css({ 'display': '' });
                });
                return true;
            },

            toggle: function() {
                var plugin = this;
                if (plugin.expanded) {
                    plugin.collapse();
                } else {
                    plugin.expand();
                }
            },

            destroy: function () {
                var plugin = this;
                // reset the markup
                plugin.$element
                    .removeClass(plugin.options.activeClass)
                    .css({ 'display': '' });
                plugin.$excerpt
                    .removeClass(plugin.options.activeClass)
                    .css({ 'display': '' });
                // unbind the listeners
                plugin.$trigger
                    .off('togglr-activate.expando')
                    .off('togglr-deactivate.expando')
                    .off('click.expando');
                // remove the data
                plugin.$element.removeData('plugin_' + pluginName);
            }

        };

        // Turn this into a jquery plugin & prevent multiple instantiations
        $.fn[pluginName] = function (options) {
            return this.each(function () {
                if (!$.data(this, 'plugin_' + pluginName)) {
                    $.data(this, 'plugin_' + pluginName,
                        new Expando(this, options));
                }
            });
        }

    })(jQuery, window, document);
});
